export type LatLng = { lat: number; lng: number }
export type LatLngPerimeter = LatLng[]

function degreesToRadians(degrees: number): number {
  return (degrees * Math.PI) / 180
}

function haversineDistance(point1: LatLng, point2: LatLng): number {
  const earthRadius = 6371e3 // Earth's radius in meters
  const dLat = degreesToRadians(point2.lat - point1.lat)
  const dLng = degreesToRadians(point2.lng - point1.lng)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(point1.lat)) *
      Math.cos(degreesToRadians(point2.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return earthRadius * c
}

function distanceFromPointToLineSegment(
  point: LatLng,
  lineStart: LatLng,
  lineEnd: LatLng,
): number {
  // If start and end are the same point, return distance to the point
  if (lineStart.lat === lineEnd.lat && lineStart.lng === lineEnd.lng) {
    return haversineDistance(point, lineStart)
  }

  // Convert all lat/lng to radians
  const pointRad = {
    lat: degreesToRadians(point.lat),
    lng: degreesToRadians(point.lng),
  }
  const startRad = {
    lat: degreesToRadians(lineStart.lat),
    lng: degreesToRadians(lineStart.lng),
  }
  const endRad = {
    lat: degreesToRadians(lineEnd.lat),
    lng: degreesToRadians(lineEnd.lng),
  }

  // Haversine formula to calculate distances
  const earthRadius = 6371e3 // Earth's radius in meters
  const dLat = endRad.lat - startRad.lat
  const dLng = endRad.lng - startRad.lng
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(startRad.lat) *
      Math.cos(endRad.lat) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const lineLength = earthRadius * c

  // Projection factor
  const t =
    ((pointRad.lat - startRad.lat) * (endRad.lat - startRad.lat) +
      (pointRad.lng - startRad.lng) * (endRad.lng - startRad.lng)) /
    (lineLength * lineLength)

  // Closest point on the line
  const closestPoint =
     
    t < 0
      ? lineStart
      : t > 1
      ? lineEnd
      : {
          lat: startRad.lat + t * (endRad.lat - startRad.lat),
          lng: startRad.lng + t * (endRad.lng - startRad.lng),
        }

  return haversineDistance(point, closestPoint)
}

export function getDistanceFromLatLngToPerimeter(
  currentLatLng: LatLng,
  perimeterLatLng: LatLngPerimeter,
): number {
  let minDistance = Number.MAX_VALUE

   
  for (let i = 0; i < perimeterLatLng.length; i++) {
    const start = perimeterLatLng[i]
    const end = perimeterLatLng[(i + 1) % perimeterLatLng.length]

    const distance = distanceFromPointToLineSegment(currentLatLng, start, end)
    if (distance < minDistance) {
      minDistance = distance
    }
  }

  return minDistance
}
